















































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({
  name: "articleDetailType3",
})
export default class extends Vue {
  private gloryImageList: any = [];
  private honorTitleIndex: any = 0;

  private honorDialogVisible: any = false;
  // 一品一码链接
  private honorSrc: any = "";
  // 只有一品一码点击才有弹框
  private honorClickFlag: any = false;

  @Prop()
  companyDetail: any;

  @Watch("companyDetail", { immediate: true, deep: true })
  oncompanyDetail(val: any, oldVal: any) {
    // this.enterpriseMienData = val;
    // console.log('companyDetail----------',val)
    if (val) {
      this.honorTitleIndex = val.imageGroup[0].id;
    }
  }

  @Watch("honorTitleIndex", { immediate: true, deep: true })
  onhonorTitleIndex(val: any, oldVal: any) {
    if (this.companyDetail) {
      // console.log('gloryImageList------',this.companyDetail)
      this.gloryImageList = this.companyDetail.gloryImageList.filter(
        (item: any) => {
          if (item.type == val) {
            return item;
          }
        }
      );
    }
  }

  private toDetail(item: any) {
    // console.log(item)
    this.$router.push({
      name: "Article",
      query: {
        type: "1",
        landmarkId: this.$route.query.landmarkId,
        id: item.id,
      },
    });
  }
  private tabHonorTitle(index: any, item: any) {
    this.honorTitleIndex = index;
    // console.log('index---', index,item)
    if (item.value == "一品一码") {
      this.honorClickFlag = true;
    } else {
      this.honorClickFlag = false;
    }
  }

  private openUrl(url: any) {
    window.open(url, "_blank");
  }

  private honorClick(item: any) {
    if (this.honorClickFlag) {
      // console.log('honorClick---', item);
      this.honorDialogVisible = true;
      this.honorSrc = item.address;
    }
  }

  private closeHonor() {
    this.honorDialogVisible = false;
  }
}
